{
    "Accessibility Menu": "Menú de accesibilidad",
    "Reset settings": "Restablecer configuración",
    "Close": "Cerrar",
    "Content Adjustments": "Ajustes de contenido",
    "Adjust Font Size": "Ajustar el tamaño de fuente",
    "Highlight Title": "Destacar título",
    "Highlight Links": "Destacar enlaces",
    "Readable Font": "Fuente legible",
    "Color Adjustments": "Ajustes de color",
    "Dark Contrast": "Contraste oscuro",
    "Light Contrast": "Contraste claro",
    "High Contrast": "Alto contraste",
    "High Saturation": "Alta saturación",
    "Low Saturation": "Baja saturación",
    "Monochrome": "Monocromo",
    "Protanopia": "Protanopía",
    "Deuteranopia": "Deuteranopía",
    "Tritanopia": "Tritanopía",
    "Visual & Navigation Aids": "Ayudas visuales y de navegación",
    "Additional Tools": "Herramientas adicionales",
    "Reading Guide": "Guía de lectura",
    "Stop Animations": "Detener animaciones",
    "Big Cursor": "Cursor grande",
    "Screen Reader": "Lector de pantalla",
    "Hide Images": "Ocultar imágenes",
    "Image Tooltips": "Información de imágenes",
    "Page Structure": "Estructura de la página",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupa",
    "Increase Font Size": "Aumentar tamaño de fuente",
    "Decrease Font Size": "Reducir tamaño de fuente",
    "Letter Spacing": "Espaciado entre letras",
    "Line Height": "Altura de línea",
    "Font Weight": "Grosor de fuente",
    "Dyslexia Font": "Fuente para dislexia",
    "Language": "Idioma",
    "Open Accessibility Menu": "Abrir menú de accesibilidad",
    "Accessibility Profiles": "Perfiles de accesibilidad",
    "Seizure Safe Profile": "Perfil de seguridad para convulsiones",
    "Stops animations and reduces color saturation.": "Detiene animaciones y reduce la saturación de color.",
    "Blind Profile": "Perfil para personas ciegas",
    "Activates the screen reader for auditory navigation.": "Activa el lector de pantalla para navegación auditiva.",
    "Visually Impaired Profile": "Perfil para discapacidad visual",
    "Enhances contrast and readability for low vision.": "Mejora el contraste y la legibilidad para baja visión.",
    "ADHD Friendly Profile": "Perfil amigable para TDAH",
    "Reduces distractions for better focus.": "Reduce distracciones para una mejor concentración.",
    "Cognitive & Learning Profile": "Perfil cognitivo y de aprendizaje",
    "Helpful tools for reading and comprehension.": "Herramientas útiles para lectura y comprensión.",
    "Motor Impaired Profile": "Perfil para discapacidad motriz",
    "Optimizes the site for keyboard-only navigation.": "Optimiza el sitio para la navegación exclusiva por teclado.",
    "Headings": "Encabezados",
    "Landmarks": "Puntos de referencia",
    "Links": "Enlaces",
    "Focus element": "Enfocar elemento",
    "Visit link": "Visitar enlace"
}